import { formatMoney } from "../common/utils";

const initialize = async (sectionData) => {
  const products = await fetchRecommendations(sectionData.productId);
  if (products && 0 < products.length) {
    renderProducts(products);
  }
};

const fetchRecommendations = async (productId, limit = 4, intent = "related") => {
  const url = `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`;
  const response = await fetch(url, {
    headers: {
      Accept: "application/json",
    },
  });
  if (!response.ok) {
    console.error("Failed to fetch recommendations", response.status);
    return [];
  }
  const data = await response.json();
  return data.products || [];
};

const renderProducts = (products) => {
  const el = document.querySelector(".gd-section-product-recommendations .gd-section-product-recommendations-products");

  el.innerHTML = products
    .map((product) => {
      if (product.images.length <= 0) {
        return "";
      }
      const price = formatMoney(product.price / 100);
      return `
        <div class="gd-section-product-recommendations-product">
          <a href="${product.url}">
            <div class="gd-image">
              <img src="${product.images[0]}" />
            </div>
            <p class="gd-vendor">${product.vendor}</p>
            <h3 class="gd-title">${product.title}</h3>
            <p class="gd-price">${price}</p>
          </a>
        </div>
      `;
    })
    .join("");
};

/*
 * main
 */

document.addEventListener("DOMContentLoaded", () => {
  if (window.kochibin.template != "product" || !window.kochibin.sections) {
    return;
  }
  const sectionData = window.kochibin.sections.find((s) => s.type == "product-recommendations");
  if (!sectionData) {
    return;
  }
  initialize(sectionData);
});
